import React from 'react';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { Form } from 'reactstrap';
import Empty from '../../Layouts/Empty';
import { Alert, Button, Input } from '../../UI/Common';
import { validationSchema } from './validation';
import helper from '../../../utils/helper';

const ChangePasswordPage = ({ t, ...props }) => {
  const { isSubmitting } = props;
  const form = {
    username: '',
    currentPassword: '',
    password: '',
    confirmPassword: '',
  };
  // const pwdValidationSchema = helper.pwdValidationSchema({
  //   containConfirm: true,
  // });
  return (
    <Empty>
      <h1>{t('Please update your password')}</h1>
      <Formik
        initialValues={form}
        // validationSchema={validationSchema.concat(pwdValidationSchema)}
        onSubmit={(values) => props.onChangePassword(values)}
      >
        {({ values, handleChange, errors, touched, handleSubmit }) => {
          return (
            <Form>
              <Input
                required
                label="Username"
                id="username"
                autoCapitalize="off"
                placeholder="Username"
                value={values.username}
                onChange={handleChange('username')}
                invalid={touched.username}
                error={errors.username}
              />
              <Input
                required
                type="password"
                label="Current Password"
                id="currentPassword"
                value={values.currentPassword}
                onChange={handleChange('currentPassword')}
                invalid={touched.currentPassword}
                error={errors.currentPassword}
              />
              <Input
                required
                type="password"
                label="New Password"
                id="password"
                value={values.password}
                onChange={handleChange('password')}
                invalid={touched.password}
                error={errors.password}
              />
              <Input
                required
                type="password"
                label="Confirm Password"
                id="confirmPassword"
                value={values.confirmPassword}
                onChange={handleChange('confirmPassword')}
                invalid={touched.confirmPassword && errors.confirmPassword}
                error={errors.confirmPassword}
              />
              <Alert.Error hasIcon text={props.errors} />
              <div className="form-group form-group-button">
                <Button
                  classes="button-block"
                  loading={isSubmitting}
                  onClick={handleSubmit}
                  id="login-button"
                >
                  {t('Change')}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Empty>
  );
};

export default withTranslation('app')(ChangePasswordPage);
